module.exports = __webpack_public_path__ + "assets/img/logo-fema.0c2c4637.svg";